import {faPen} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {Locale} from '../../../../../provider/locale/localization';

import * as styles from './review-presence-action.scss';

export function ReviewPresenceAction(): JSX.Element {
    return (
        <div className={styles.ReviewPresenceAction}>
            <FontAwesomeIcon className={styles.ReviewPresenceAction_icon} icon={faPen} />
            <Locale stringKey="REVIEWS__PRESENCE__ANOTHER_USER" />
        </div>
    );
}
